import { createRouter, createWebHistory } from 'vue-router'
import HomeView from './views/HomeView.vue'
import ExamView from './views/ExamView.vue'
import ExamSetSelectView from './views/ExamSetSelectView.vue'
import SignupView from './views/SignupView.vue'
import PerformanceView from './views/PerformanceView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/exam-select/:year/:subject',
    name: 'exam-select',
    component: ExamSetSelectView,
    props: true
  },
  {
    path: '/exam/:year/:subject/:setId',
    name: 'exam',
    component: ExamView,
    props: true
  },
  {
    path: '/signup',
    name: 'signup',
    component: SignupView
    // We can pass query params to it if needed, e.g., to redirect after login
  },
  {
    path: '/performance',
    name: 'performance',
    component: PerformanceView,
    meta: { requiresAuth: true } // Add meta field for route guard
  },
  // Add a redirect route for incomplete exam URLs
  {
    path: '/exam/:year/:subject',
    redirect: to => {
      return `/exam-select/${to.params.year}/${to.params.subject}`
    }
  },
  // Catch-all route for debugging (optional)
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('./views/NotFoundView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

import { useAuth } from './composables/useAuth'; // Import useAuth

// Navigation Guard
router.beforeEach(async (to, from, next) => {
  const { currentUser, loading } = useAuth(); // Get auth state

  // Wait for Firebase to initialize auth state
  if (loading.value) {
    // This is a simplified way; ideally, you'd have a proper loading state
    // or use onAuthStateChanged directly here if not using a composable that handles initial loading.
    // For now, we'll rely on the composable's loading state.
    // A better approach might involve a watcher or a promise from useAuth.
    // This simple check might cause a flicker or race condition if auth state isn't ready.
    // A more robust solution would be to ensure currentUser is definitively set or null.
    // One way is to await a promise that resolves when auth is initialized.
    // For this example, we'll proceed, but be mindful of this in production.
  }

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser.value) {
    // If route requires auth and user is not logged in, redirect to signup
    // Pass the intended route as a query param for redirection after login
    next({ name: 'signup', query: { redirect: to.fullPath } });
  } else {
    // Otherwise, proceed as normal
    next();
  }
});

export default router